"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GFModeUtils = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const trade_utils_lib_1 = require("trade_utils_lib");
const react_1 = require("react");
const trade_quotation_lib_1 = require("trade_quotation_lib");
const parseLiquidationForMode_1 = require("../Tools/parseLiquidationForMode");
var GFModeUtils;
(function (GFModeUtils) {
    const parseInputRealAndDisplayParams = (params) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        const { mode, trend, symbolInfo, symbolDisplay, currentPrice, top, bottom, triggerPrice, stopLossType, stopLostHighPrice, stopLostPrice, stopLostLimitHighPrice, stopLostLimitPrice, takeProfitType, takeProfitLimitPrice, takeProfitPrice, } = params;
        const isTPByPrice = takeProfitType === TradeAPILib_1.GridStopType.price || takeProfitType === TradeAPILib_1.GridStopType.price_limit;
        const isNoTrend = trend === TradeAPILib_1.GridFuturesTrend.no_trend;
        let stopLostPriceReal = (_a = GFModeUtils.parseValue(stopLostPrice)) !== null && _a !== void 0 ? _a : "";
        let stopLostPriceDisplay = (_b = GFModeUtils.parseValue(stopLostPrice)) !== null && _b !== void 0 ? _b : "";
        let stopLostLimitPriceReal = GFModeUtils.parseValue(stopLostLimitPrice);
        let stopLostLimitPriceDisplay = GFModeUtils.parseValue(stopLostLimitPrice);
        let stopLostHighPriceReal = GFModeUtils.parseValue(stopLostHighPrice);
        let stopLostHighPriceDisplay = GFModeUtils.parseValue(stopLostHighPrice);
        let stopLostLimitHighPriceReal = GFModeUtils.parseValue(stopLostLimitHighPrice);
        let stopLostLimitHighPriceDisplay = GFModeUtils.parseValue(stopLostLimitHighPrice);
        let takeProfitPriceReal = (_c = GFModeUtils.parseValue(takeProfitPrice)) !== null && _c !== void 0 ? _c : "";
        let takeProfitPriceDisplay = (_d = GFModeUtils.parseValue(takeProfitPrice)) !== null && _d !== void 0 ? _d : "";
        let takeProfitLimitPriceReal = GFModeUtils.parseValue(takeProfitLimitPrice);
        let takeProfitLimitPriceDisplay = GFModeUtils.parseValue(takeProfitLimitPrice);
        // 币本位时
        if (mode === TradeAPILib_1.GridFuturesMode.coin_m) {
            const trendReal = reverseTrend(trend);
            /** 实际给后端的价格的精度 例: USDT.PERP/BTC */
            const realPrecision = (_e = symbolInfo.precision) !== null && _e !== void 0 ? _e : 0;
            /** 展示给用户的精度 例: BTC.PERP.USDT */
            const displayPrecision = (_f = symbolDisplay === null || symbolDisplay === void 0 ? void 0 : symbolDisplay.precision) !== null && _f !== void 0 ? _f : 0;
            const currentPriceDisplay = backwardsValue(currentPrice);
            const topReal = (_g = backwardsValue(bottom, realPrecision)) !== null && _g !== void 0 ? _g : "";
            const bottomReal = (_h = backwardsValue(top, realPrecision)) !== null && _h !== void 0 ? _h : "";
            const topDisplay = (_j = backwardsValue(bottomReal, displayPrecision)) !== null && _j !== void 0 ? _j : "";
            const bottomDisplay = (_k = backwardsValue(topReal, displayPrecision)) !== null && _k !== void 0 ? _k : "";
            const triggerReal = backwardsValue(triggerPrice, realPrecision);
            const triggerDisplay = backwardsValue(triggerReal, displayPrecision);
            const isSLByPrice = stopLossType === TradeAPILib_1.GridStopType.price || stopLossType === TradeAPILib_1.GridStopType.price_limit;
            if (isSLByPrice) {
                stopLostPriceReal = (_l = backwardsValue(stopLostPrice, realPrecision)) !== null && _l !== void 0 ? _l : "";
                stopLostPriceDisplay = (_m = backwardsValue(stopLostPriceReal, displayPrecision)) !== null && _m !== void 0 ? _m : "";
                stopLostLimitPriceReal = backwardsValue(stopLostLimitPrice, realPrecision);
                stopLostLimitPriceDisplay = backwardsValue(stopLostLimitPriceReal, displayPrecision);
                stopLostHighPriceReal = backwardsValue(stopLostHighPrice, realPrecision);
                stopLostHighPriceDisplay = backwardsValue(stopLostHighPriceReal, displayPrecision);
                stopLostLimitHighPriceReal = backwardsValue(stopLostLimitHighPrice, realPrecision);
                stopLostLimitHighPriceDisplay = backwardsValue(stopLostLimitHighPriceReal, displayPrecision);
            }
            // 中性网格价格止盈时 price 字段是次数, 不需要做倒数
            if (isTPByPrice && !isNoTrend) {
                takeProfitPriceReal = (_o = backwardsValue(takeProfitPrice, realPrecision)) !== null && _o !== void 0 ? _o : "";
                takeProfitPriceDisplay = (_p = backwardsValue(takeProfitPriceReal, displayPrecision)) !== null && _p !== void 0 ? _p : "";
                takeProfitLimitPriceReal = backwardsValue(takeProfitLimitPrice, realPrecision);
                takeProfitLimitPriceDisplay = backwardsValue(takeProfitLimitPriceReal, displayPrecision);
            }
            return {
                trendReal,
                currentPriceDisplay,
                topReal,
                topDisplay,
                bottomReal,
                bottomDisplay,
                triggerReal,
                triggerDisplay,
                stopLostPriceReal,
                stopLostLimitPriceReal,
                stopLostHighPriceReal,
                stopLostLimitHighPriceReal,
                takeProfitPriceReal: takeProfitPriceReal !== null && takeProfitPriceReal !== void 0 ? takeProfitPriceReal : "",
                takeProfitLimitPriceReal,
                stopLostPriceDisplay,
                stopLostLimitPriceDisplay,
                stopLostHighPriceDisplay,
                stopLostLimitHighPriceDisplay,
                takeProfitPriceDisplay: takeProfitPriceDisplay !== null && takeProfitPriceDisplay !== void 0 ? takeProfitPriceDisplay : "",
                takeProfitLimitPriceDisplay,
            };
        }
        return {
            trendReal: trend,
            currentPriceDisplay: currentPrice,
            topReal: top,
            topDisplay: top,
            bottomReal: bottom,
            bottomDisplay: bottom,
            triggerReal: triggerPrice,
            triggerDisplay: triggerPrice,
            stopLostPriceReal: stopLostPrice || "",
            stopLostLimitPriceReal: stopLostLimitPrice,
            stopLostHighPriceReal: stopLostHighPrice,
            stopLostLimitHighPriceReal: stopLostLimitHighPrice,
            takeProfitPriceReal: takeProfitPrice || "",
            takeProfitLimitPriceReal: takeProfitLimitPrice,
            stopLostPriceDisplay: stopLostPrice || "",
            stopLostLimitPriceDisplay: stopLostLimitPrice,
            stopLostHighPriceDisplay: stopLostHighPrice,
            stopLostLimitHighPriceDisplay: stopLostLimitHighPrice,
            takeProfitPriceDisplay: takeProfitPrice || "",
            takeProfitLimitPriceDisplay: takeProfitLimitPrice,
        };
    };
    GFModeUtils.useRealAndDisplayParams = (params) => {
        const deps = Object.values(params);
        return (0, react_1.useMemo)(() => parseInputRealAndDisplayParams(params), deps);
    };
    GFModeUtils.parseRealToDisplayParams = (params) => {
        var _a, _b, _c, _d, _e;
        const { mode, symbolInfo, trend, top, bottom, currentPrice, triggerPrice, stopLossType, stopLostPrice, stopLostHighPrice, stopLostLimitPrice, stopLostLimitHighPrice, takeProfitType, takeProfitPrice, takeProfitLimitPrice, liquidation, liquidationDown, liquidationUp, agvPrice, } = params;
        const isTPByPrice = takeProfitType && GFModeUtils.isTPSLTypeByPrice(takeProfitType);
        const isNoTrend = trend === TradeAPILib_1.GridFuturesTrend.no_trend;
        let stopLostPriceReal = GFModeUtils.parseValue(stopLostPrice);
        let stopLostPriceDisplay = GFModeUtils.parseValue(stopLostPrice);
        let stopLostHighPriceReal = GFModeUtils.parseValue(stopLostHighPrice);
        let stopLostHighPriceDisplay = GFModeUtils.parseValue(stopLostHighPrice);
        let stopLostLimitPriceReal = GFModeUtils.parseValue(stopLostLimitPrice);
        let stopLostLimitPriceDisplay = GFModeUtils.parseValue(stopLostLimitPrice);
        let stopLostLimitHighPriceReal = GFModeUtils.parseValue(stopLostLimitHighPrice);
        let stopLostLimitHighPriceDisplay = GFModeUtils.parseValue(stopLostLimitHighPrice);
        let takeProfitPriceReal = GFModeUtils.parseValue(takeProfitPrice);
        let takeProfitPriceDisplay = GFModeUtils.parseValue(takeProfitPrice);
        let takeProfitLimitPriceReal = GFModeUtils.parseValue(takeProfitLimitPrice);
        let takeProfitLimitPriceDisplay = GFModeUtils.parseValue(takeProfitLimitPrice);
        if (mode === TradeAPILib_1.GridFuturesMode.coin_m) {
            const symbolDisplay = trade_quotation_lib_1.SymbolDataProvider.getSymbol(symbolInfo.quote + ".PERP", (_b = (_a = symbolInfo.base) === null || _a === void 0 ? void 0 : _a.split(".")) === null || _b === void 0 ? void 0 : _b[0]) || symbolInfo;
            /** 展示给用户的精度 例: BTC.PERP.USDT */
            const displayPrecision = (_c = symbolDisplay === null || symbolDisplay === void 0 ? void 0 : symbolDisplay.precision) !== null && _c !== void 0 ? _c : 0;
            const topDisplay = (_d = backwardsValue(bottom, displayPrecision)) !== null && _d !== void 0 ? _d : "";
            const bottomDisplay = (_e = backwardsValue(top, displayPrecision)) !== null && _e !== void 0 ? _e : "";
            const trendDisplay = reverseTrend(trend);
            const { up: liquidationUpDisplay, down: liquidationDownDisplay } = (0, parseLiquidationForMode_1.parseLiquidationDisplayForMode)({
                mode,
                liquidationDown,
                liquidationUp,
                precision: displayPrecision,
            });
            if (stopLossType && GFModeUtils.isTPSLTypeByPrice(stopLossType)) {
                stopLostPriceDisplay = backwardsValue(stopLostPrice, displayPrecision);
                stopLostHighPriceDisplay = backwardsValue(stopLostHighPrice, displayPrecision);
                stopLostLimitPriceDisplay = backwardsValue(stopLostLimitPrice, displayPrecision);
                stopLostLimitHighPriceDisplay = backwardsValue(stopLostLimitHighPrice, displayPrecision);
            }
            if (takeProfitType && !isNoTrend && isTPByPrice) {
                takeProfitPriceDisplay = backwardsValue(takeProfitPrice, displayPrecision);
                takeProfitLimitPriceDisplay = backwardsValue(takeProfitLimitPrice, displayPrecision);
            }
            return {
                mode,
                symbolReal: symbolInfo,
                symbolDisplay: symbolDisplay,
                topReal: top,
                bottomReal: bottom,
                topDisplay: topDisplay,
                bottomDisplay: bottomDisplay,
                trendReal: trend,
                trendDisplay: trendDisplay,
                currentPrice: currentPrice,
                currentPriceDisplay: backwardsValue(currentPrice, displayPrecision),
                triggerReal: triggerPrice,
                triggerDisplay: backwardsValue(triggerPrice, displayPrecision),
                stopLostPriceReal,
                stopLostPriceDisplay,
                stopLostHighPriceReal,
                stopLostHighPriceDisplay,
                stopLostLimitPriceReal,
                stopLostLimitPriceDisplay,
                stopLostLimitHighPriceReal,
                stopLostLimitHighPriceDisplay,
                takeProfitPriceReal,
                takeProfitPriceDisplay,
                takeProfitLimitPriceReal,
                takeProfitLimitPriceDisplay,
                liquidationReal: liquidation,
                liquidationDisplay: backwardsValue(liquidation, displayPrecision),
                liquidationUpReal: liquidationUp,
                liquidationUpDisplay: liquidationUpDisplay,
                liquidationDownReal: liquidationDown,
                liquidationDownDisplay: liquidationDownDisplay,
                agvPriceReal: agvPrice,
                agvPriceDisplay: backwardsValue(agvPrice, displayPrecision),
            };
        }
        return {
            mode,
            symbolReal: symbolInfo,
            symbolDisplay: symbolInfo,
            topReal: top,
            bottomReal: bottom,
            topDisplay: top,
            bottomDisplay: bottom,
            trendReal: trend,
            trendDisplay: trend,
            currentPrice: currentPrice,
            currentPriceDisplay: currentPrice,
            triggerReal: triggerPrice,
            triggerDisplay: triggerPrice,
            stopLostPriceReal,
            stopLostPriceDisplay,
            stopLostHighPriceReal,
            stopLostHighPriceDisplay,
            stopLostLimitPriceReal,
            stopLostLimitPriceDisplay,
            stopLostLimitHighPriceReal,
            stopLostLimitHighPriceDisplay,
            takeProfitPriceReal,
            takeProfitPriceDisplay,
            takeProfitLimitPriceReal,
            takeProfitLimitPriceDisplay,
            liquidationReal: liquidation,
            liquidationDisplay: liquidation,
            liquidationUpReal: liquidationUp,
            liquidationUpDisplay: liquidationUp,
            liquidationDownReal: liquidationDown,
            liquidationDownDisplay: liquidationDown,
            agvPriceReal: agvPrice,
            agvPriceDisplay: agvPrice,
        };
    };
    GFModeUtils.parseInputPriceToReal = (value, realPrecision, mode) => {
        if (mode !== TradeAPILib_1.GridFuturesMode.coin_m) {
            return value;
        }
        return backwardsValue(value, realPrecision);
    };
    GFModeUtils.parseRealPriceToDisplay = (value, displayPrecision, mode) => {
        if (mode !== TradeAPILib_1.GridFuturesMode.coin_m) {
            return value;
        }
        return backwardsValue(value, displayPrecision);
    };
    GFModeUtils.isTPSLTypeByPrice = (type) => {
        return type === TradeAPILib_1.GridStopType.price || type === TradeAPILib_1.GridStopType.price_limit;
    };
    GFModeUtils.parseValue = (value) => {
        if (value === "+" || value === "-") {
            return "";
        }
        return value;
    };
    const one = new trade_utils_lib_1.SafeDecimal(1);
    const backwardsValue = (valueOri, precision) => {
        const value = GFModeUtils.parseValue(valueOri);
        if (!value) {
            return value;
        }
        const valueD = new trade_utils_lib_1.SafeDecimal(value);
        if (valueD.isZero()) {
            return "0";
        }
        const res = one.div(valueD);
        if (precision !== undefined) {
            return res.toFixed(precision, trade_utils_lib_1.SafeDecimal.ROUND_DOWN);
        }
        else {
            return res.toFixed();
        }
    };
    const reverseTrend = (trend) => {
        if (trend === TradeAPILib_1.GridFuturesTrend.long) {
            return TradeAPILib_1.GridFuturesTrend.short;
        }
        else if (trend === TradeAPILib_1.GridFuturesTrend.short) {
            return TradeAPILib_1.GridFuturesTrend.long;
        }
        return trend;
    };
    /**
     * 是否是合约网格币本位, 直接用orderType和mode的值判断
     * 适用于无法获取到 order 的场景
     * @param orderType
     * @param mode
     * @returns {boolean}
     */
    function isFuturesCMMode(orderType, mode) {
        return orderType === TradeAPILib_1.ExchangeOrderType.gridV4Futures && mode === TradeAPILib_1.GridFuturesMode.coin_m;
    }
    GFModeUtils.isFuturesCMMode = isFuturesCMMode;
    /**
     * 是否是合约网格币本位, 通过order判断
     * @param order
     * @returns {boolean}
     */
    function isFuturesCMModeByOrder(order) {
        const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(order);
        return isFuturesCMMode(order.orderType, innerOrder.mode);
    }
    GFModeUtils.isFuturesCMModeByOrder = isFuturesCMModeByOrder;
})(GFModeUtils || (exports.GFModeUtils = GFModeUtils = {}));
